import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["choice", "file", "save"]
  static values = { targetId: String }
  connect() {
    this.parent = document.getElementById(this.targetIdValue)
    this.initialSelection = this.parent?.dataset.imageSelectableSelectionValue || ""
    const choice = this.choiceTargets.find(({ value }) => value === this.initialSelection)
    if (choice) choice.checked = true
    this.#copyPendingUpload()
    this.#syncSave()
  }
  selectChoice() { this.#syncSave() }

  selectFile() {
    if (this.fileTarget.files.length > 0) {
      this.choiceTargets.find(({ value }) => value === "upload").checked = true
    }
    this.#syncSave()
  }

  confirm() {
    const choice = this.choiceTargets.find(({ checked }) => checked)
    const preset = choice.value.startsWith("preset:")
    this.dispatch("confirmed", { target: document, detail: {
      targetId: this.targetIdValue,
      kind: preset ? "preset" : "upload",
      preset: preset ? choice.value.replace("preset:", "") : null,
      previewUrl: choice.dataset.imageSelectableSelectionPreviewUrlParam,
      label: choice.dataset.imageSelectableSelectionLabelParam,
      files: this.fileTarget.files
    } })
  }

  #copyPendingUpload() {
    if (this.initialSelection !== "upload") return
    const parentFile = this.parent?.querySelector("[data-image-selectable-target='file']")
    if (!parentFile || parentFile.files.length === 0) return

    this.fileTarget.files = parentFile.files
    this.fileTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  #syncSave() {
    const choice = this.choiceTargets.find(({ checked }) => checked)
    const uploadAvailable = this.fileTarget.files.length > 0 || this.initialSelection === "upload"
    this.saveTarget.disabled = !choice || (choice.value === "upload" && !uploadAvailable)
  }
}
